export const Home = {
	headerBackground: require('assets/images/Home/headerBackground.jpg'),
	headerTablet: require('assets/images/Home/headerTablet.png'),
	quickbooks: require('assets/images/Home/quickbooks.png'),
	bodyTablet: require('assets/images/Home/bodyTablet.png'),
	directTraffic: require('assets/images/Home/directTrafficControl.png'),
	roadBuilders: require('assets/images/Home/roadBuilders.png'),
	atssa: require('assets/images/Home/atssa.png'),
	d2k: require('assets/images/Home/d2k.png'),
	devices: require('assets/images/Home/devices.png'),
	devicesNoShadow: require('assets/images/Home/devicesNoShadow.png'),
}
